import React from "react";
import { ContactEmail, PolicyPage, PolicySection } from "./PolicyPage";

function Delivery() {
  return (
    <PolicyPage
      title="Shipping & Delivery Policy"
      intro="This policy explains processing, delivery estimates, customs, address changes, tracking, and what to do when a parcel is delayed or missing."
    >
      <PolicySection title="1. Order processing">
        <p>
          Orders are generally prepared within 2–3 business days and may require up to
          5–7 business days depending on product availability, verification, and peak
          periods. Business days exclude weekends and applicable public holidays.
          Processing time is separate from carrier transit time.
        </p>
        <p>
          Customized, pre-order, or back-order items may have a different lead time on
          the product page or in your order confirmation. If an unexpected material
          delay affects your order, we will use the contact details supplied at checkout.
        </p>
      </PolicySection>

      <PolicySection title="2. Methods, rates, and estimates">
        <p>
          Available destinations, delivery services, charges, and estimates are shown
          at checkout when available. Any free-shipping threshold or expedited option
          is governed by the offer and checkout display in effect when you order.
          Delivery estimates begin after dispatch and are not guarantees unless we
          expressly state otherwise.
        </p>
      </PolicySection>

      <PolicySection title="3. Address accuracy and changes">
        <p>
          You are responsible for a complete deliverable address, including apartment,
          unit, company, and postal details. Contact <ContactEmail subject="Shipping address change" /> immediately if a correction is needed. We cannot promise a change after an order enters processing or is handed to a carrier. Additional costs caused by an incorrect address may be charged where lawful.
        </p>
      </PolicySection>

      <PolicySection title="4. Tracking and delivery">
        <p>
          Tracking details are sent after dispatch when offered by the carrier. A scan
          may take time to appear. Some carriers transfer parcels to a local service for
          final delivery. Signature or identity checks may apply to certain destinations
          or order values.
        </p>
      </PolicySection>

      <PolicySection title="5. International orders, duties, and taxes">
        <p>
          International delivery is available only to supported destinations. Unless
          checkout expressly states that duties and taxes are included, the order is
          sent duties unpaid and the recipient is responsible for import duties, taxes,
          brokerage, and customs charges. Customs may delay or inspect a parcel. We do
          not control those charges or processes and cannot declare a false value or
          mark a commercial purchase as a gift.
        </p>
      </PolicySection>

      <PolicySection title="6. Delays">
        <p>
          Weather, customs, high-volume periods, labor events, carrier disruptions,
          emergencies, and other circumstances outside reasonable control can delay
          delivery. If tracking has not changed for more than five business days, email
          us and we will help request a carrier investigation. An investigation can take
          additional time and does not always allow immediate replacement or refund.
        </p>
      </PolicySection>

      <PolicySection title="7. Marked delivered but not received">
        <p>
          Check the delivery address, household members, reception or mailroom, safe
          locations, and neighbors, then allow up to three business days because some
          carriers scan before final handoff. If the parcel is still missing, contact us
          promptly. We will review tracking and assist with a claim. Remedies depend on
          the investigation and applicable consumer law.
        </p>
      </PolicySection>

      <PolicySection title="8. Lost, damaged, refused, or returned parcels">
        <p>
          Report visible transit damage promptly and keep the item, box, labels, and
          packing materials for assessment. If a carrier confirms loss, or a package is
          returned to us, we will contact you about lawful refund or reshipment options.
          Extra costs caused by refusal, failure to collect, customs non-payment, or an
          inaccurate address may be deducted or recharged where permitted.
        </p>
      </PolicySection>

      <PolicySection title="9. Risk and consumer rights">
        <p>
          Risk passes at the time required by the law applicable to your purchase. For
          consumers, this will generally not be before you or a person you identify
          physically receives the goods, except where you independently appoint a
          carrier not offered by us. This policy does not limit mandatory delivery
          rights.
        </p>
      </PolicySection>
    </PolicyPage>
  );
}

export default Delivery;
